import { Box, List, ListItem, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { AppLink } from 'shared/ui/AppLink/AppLink';

import { PageNavItem } from '../model/types/PageNavBarTypes';

const SUB_NAV_WIDTH = '272px';

interface PageNavbarProps {
    navList: PageNavItem[];
    title?: string | null;
}

export const PageNavbar = ({ navList, title }: PageNavbarProps) => {
    const location = useLocation();
    const hasItems = navList?.length > 0;

    if (!hasItems) {
        return null;
    }

    return (
        <Box
            data-testid="Sub-menu"
            sx={{
                width: SUB_NAV_WIDTH,
                minWidth: SUB_NAV_WIDTH,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
            }}
        >
            {title ? (
                <Typography
                    data-testid="Sub-menu-title"
                    variant="h4"
                    sx={{
                        color: '#363636',
                        marginTop: '26px',
                        marginBottom: '28px',
                        marginLeft: '16px',
                    }}
                >
                    {title}
                </Typography>
            ) : null}
            <List
                disablePadding
                data-testid="properties-list"
                sx={{
                    flex: 1,
                    paddingTop: title ? 0 : '16px',
                }}
            >
                {navList.map((item) => {
                    const { label } = item;
                    const key = item?.key;
                    const route = item?.route;
                    const isActiveNav = item?.isActive;
                    const action = item.disabled ? () => {} : item?.action;

                    const isActive = route
                        ? location.pathname === item.route
                        : isActiveNav;

                    const componentProps = route
                        ? {
                              component: AppLink,
                              to: route,
                              replace: true,
                          }
                        : {
                              onClick: () => action(),
                          };

                    return (
                        <ListItem
                            data-testid="Sub-menu-property"
                            key={key}
                            disablePadding
                            sx={{
                                bgcolor: isActive
                                    ? 'rgba(63, 110, 183, 0.1)'
                                    : 'transparent',
                                ':hover': {
                                    bgcolor: isActive
                                        ? 'rgba(63, 110, 183, 0.1)'
                                        : 'action.hover',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            <Box
                                {...componentProps}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '9px 16px',
                                    borderLeft: '2px solid',
                                    borderColor: isActive
                                        ? 'primary.main'
                                        : 'transparent',
                                }}
                            >
                                <Typography
                                    component="span"
                                    variant="subtitle2"
                                    sx={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: 'inline-block',
                                        flex: 1,
                                        color: isActive
                                            ? 'primary.main'
                                            : 'rgba(54, 54, 54, 0.6)',
                                    }}
                                >
                                    {label}
                                </Typography>
                            </Box>
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );
};
